import { createClient } from '@supabase/supabase-js';

export const supabase = createClient(
  'https://sobwjerfyggteiczpohk.supabase.co',
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InNvYndqZXJmeWdndGVpY3pwb2hrIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzYzNTM2MTAsImV4cCI6MjA5MTkyOTYxMH0.Z3gga5WgRLObwvQq4PVhMr0pYZ8MB0itgVE6hpue3c0'
);